import { Notification } from '@copera/notification';
import { axios } from 'src/utils/axios';

/**
 * @deprecated use NotificationType from @copera/notification instead
 */
export const NotificationType = {
  CHAT: {
    CHANNEL: {
      NEW: 'chat:channel:new',
      TEXT: {
        NEW_TEXT: 'chat:channel:new-text-message',
        NEW_FILE: 'chat:channel:new-file-message',
        NEW_IMAGE: 'chat:channel:new-image-message',
        NEW_LINK: 'chat:channel:new-link-message',
      },
      VOICE: {
        ENTERING: 'chat:channel:voice-entering',
        LEAVING: 'chat:channel:voice-leaving',
        SCREENSHARINGSTART: 'chat:channel:voice-sharing-start',
        SCREENSHARINGEND: 'chat:channel:voice-sharing-end',
        INVITE: 'chat:channel:voice-invite',
        MUTE: 'chat:channel:voice-mute',
        DEAF: 'chat:channel:voice-deaf',
      },
      DELETE: 'chat:channel:delete',
    },
  },
  DOCS: {
    SHARED: 'docs:shared',
  },
  TASK: {
    ASSIGNED: 'task:assigned',
    COMPLETED: 'task:completed',
    DEADLINE: 'task:deadline',
    COMMENT: {
      NEW: 'task:comment:new',
    },
  },
  WORKSPACE: {
    USER: {
      NEW: 'workspace:user:new',
    },
  },
};

export enum NotificationStatus {
  UNREAD = 'unread',
  READ = 'read',
}

export type NotificationResponse = {
  notifications: Notification[];
  unreadCount: number;
  count: number;
};

export async function getNotifications(): Promise<NotificationResponse> {
  const { data } = await axios.get<NotificationResponse>(`/notification`);

  return data;
}

export async function markAllAsRead(): Promise<void> {
  const { data } = await axios.patch<void>(`/notification/mark-all-as-read`);

  return data;
}

export async function updateNotification({
  id,
  status,
}: {
  id: string;
  status: NotificationStatus;
}): Promise<Notification> {
  const { data } = await axios.patch<Notification>(`/notification/${id}`, {
    status,
  });

  return data;
}

type DeleteAllResponse = {
  deletedCount: number;
  allNotifications: boolean;
};
export async function deleteAll(): Promise<DeleteAllResponse> {
  const { data } = await axios.delete<DeleteAllResponse>(`/notification/all`);

  return data;
}

type DeleteOneResponse = {
  _id: string;
};
export async function deleteOne(
  notificationId: string,
): Promise<DeleteOneResponse> {
  const { data } = await axios.delete<DeleteOneResponse>(
    `/notification/${notificationId}`,
  );

  return data;
}

export * as NotificationsRequests from './notifications.requests';
